import React from "react";
import { useTranslation } from "react-i18next";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import KeyFigures from "../KeyFigures/KeyFigures";
import "./GuestCharts.css";

export const DEFAULT_PUBLIC_STATS = {
  updatedAt: "2026-07-15T10:30:00Z",
  keyFigures: [
    {
      key: "participants",
      value: 2478,
      labelKey: "landing.recurrent",
      label: "Participants",
      detailKey: "landing.percentage_org",
      detail: "Organizations connected to the data space",
      tone: "blue",
    },
    {
      key: "datasets",
      value: 219820,
      labelKey: "landing.dataset_pub",
      label: "Published datasets",
      detailKey: "landing.num_datasets",
      detail: "Datasets available in the catalogue",
      tone: "green",
    },
    {
      key: "datamodels",
      value: 213,
      labelKey: "landing.dataModel_publish",
      label: "Published data models",
      detailKey: "landing.percentage_contracts",
      detail: "Reusable vocabularies and semantic models",
      tone: "amber",
    },
  ],
  latestOfferings: [
    {
      id: "offer-1",
      updatedAt: "2026-07-12T09:15:00Z",
      title: "Urban mobility sensor readings",
      description: "Traffic intensity, parking rotation and public transport flow.",
      publisher: "Regional Transport Authority",
    },
    {
      id: "offer-2",
      updatedAt: "2026-07-10T13:40:00Z",
      title: "Primary care service indicators",
      description: "Aggregated service availability and appointment indicators.",
      publisher: "Public Health Observatory",
    },
    {
      id: "offer-3",
      updatedAt: "2026-07-08T16:05:00Z",
      title: "Tourism accommodation occupancy",
      description: "Monthly trends for hotel, rural and short-stay accommodation.",
      publisher: "Tourism Intelligence Office",
    },
    {
      id: "offer-4",
      updatedAt: "2026-07-05T08:30:00Z",
      title: "Air quality monitoring stations",
      description: "Environmental observations from public monitoring points.",
      publisher: "Environment and Climate Office",
    },
  ],
};

const formatDate = (value, language) => {
  if (!value) return "";

  try {
    return new Intl.DateTimeFormat(language || "en", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(value));
  } catch {
    return value;
  }
};

const GuestCharts = ({ stats = DEFAULT_PUBLIC_STATS }) => {
  const { t, i18n } = useTranslation();
  const figures = stats?.keyFigures ?? DEFAULT_PUBLIC_STATS.keyFigures;
  const latestOfferings =
    stats?.latestOfferings ?? DEFAULT_PUBLIC_STATS.latestOfferings;

  return (
    <div className="public-data-dashboard">
      <KeyFigures figures={figures} />

      <section className="public-home-grid">
        <article className="public-latest-card">
          <div className="public-card-heading">
            <TrendingUpOutlinedIcon fontSize="small" />
            <div>
              <h3>
                {t("datatable.lastOffering", {
                  defaultValue: "Latest offerings",
                })}
              </h3>
              <p>
                {t("publicWebsite.dataDashboard.latestOfferingsHint", {
                  defaultValue: "Recently updated public catalogue entries",
                })}
              </p>
            </div>
          </div>
          <div className="public-offering-list">
            {latestOfferings.map((offering) => (
              <article className="public-offering-row" key={offering.id}>
                <div className="public-offering-date">
                  <CalendarTodayOutlinedIcon fontSize="small" />
                  <span>{formatDate(offering.updatedAt, i18n?.language)}</span>
                </div>
                <div className="public-offering-main">
                  <h4>{offering.title}</h4>
                  <p>{offering.description}</p>
                  <div className="public-offering-publisher">
                    <BusinessOutlinedIcon fontSize="small" />
                    <span>{offering.publisher}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </article>
      </section>
    </div>
  );
};

export default GuestCharts;
